export class AbortableSupabaseQuery {
  constructor() {
    this.aborted = false;
  }

  abort() {
    this.aborted = true;
  }

  isAborted() {
    return this.aborted;
  }

  async execute(queryFn) {
    if (this.aborted) {
      throw { name: 'AbortError', message: 'Query aborted' };
    }

    const result = await queryFn();

    if (this.aborted) {
      throw { name: 'AbortError', message: 'Query aborted' };
    }

    return result;
  }
}

export function createAbortableQuery() {
  return new AbortableSupabaseQuery();
}

export function isAbortError(error) {
  return error?.name === 'AbortError';
}
